'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dAccounts$002dPage$0024 from "./presto.-List-Accounts-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002471 from "./presto.-Presto-Router$$anon$71.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$70() {
  this.blr = null;
  this.blj = null;
  this.blk = false;
  this.bls = null;
  this.blt = false;
  this.blw = null;
  this.blp = null;
  this.blq = false;
  this.bll = null;
  this.blm = false;
  this.bln = null;
  this.blo = false;
  this.blu = false;
  this.blv = false;
  this.blr = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.blw = "ListAccountsPage";
}
export { $c_Lpresto_PrestoRouter$$anon$70 as $c_Lpresto_PrestoRouter$$anon$70 };
$p = $c_Lpresto_PrestoRouter$$anon$70.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$70;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$70() {
}
export { $h_Lpresto_PrestoRouter$$anon$70 as $h_Lpresto_PrestoRouter$$anon$70 };
$h_Lpresto_PrestoRouter$$anon$70.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.blr;
});
$p.M = (function() {
  if ((!this.blk)) {
    this.blj = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.blk = true;
  }
  return this.blj;
});
$p.O = (function() {
  if ((!this.blt)) {
    this.bls = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.blt = true;
  }
  return this.bls;
});
$p.E = (function() {
  return this.blw;
});
$p.t = (function() {
  if ((!this.blq)) {
    this.blp = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.blq = true;
  }
  return this.blp;
});
$p.N = (function() {
  if ((!this.blm)) {
    this.bll = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.blm = true;
  }
  return this.bll;
});
$p.Q = (function() {
  if ((!this.blo)) {
    this.bln = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002471.$c_Lpresto_PrestoRouter$$anon$71();
    this.blo = true;
  }
  return this.bln;
});
$p.v = (function() {
  if ((!this.blv)) {
    this.blu = false;
    this.blv = true;
  }
  return this.blu;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee494) => ((p) => \u03b4scrutinee494))($j_presto$002e$002dList$002dAccounts$002dPage$0024.$m_Lpresto_ListAccountsPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$70 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$70, "presto.PrestoRouter$$anon$70", ({
  ON: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$70 as $d_Lpresto_PrestoRouter$$anon$70 };
//# sourceMappingURL=presto.-Presto-Router$$anon$70.js.map
